import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';

import {bindDispatch} from 'app/utils/redux';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';

import {ForgetPasswordView} from 'dk-ui-lib';

class ForgetPasswordContainer extends Component {

  componentWillUnmount() {
    let {login: {hasEmailSent}, actions: {updateEmail, updatePassword, updateEmailSentFlag}} = this.props;  
    if (hasEmailSent) {
      updateEmail('');
      updatePassword('');
      updateEmailSentFlag(false);
    }
  }

  render() {
    let {login, actions} = this.props;
    let {updateEmail, initiateForgetPassword} = actions;

    return (
      <div className='m2 flex justify-center'>
        <ForgetPasswordView
          login={login}
          history={history}
          routePath={routePath}
          updateEmail={updateEmail}
          initiateForgetPassword={initiateForgetPassword}
        />
      </div>
    );
  }
}

const selector = createSelector(
  state => state.login,
  (login) => ({ login })
);

ForgetPasswordContainer.propTypes = {
  login: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default connect(selector, bindDispatch)(ForgetPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/profile/ForgetPasswordContainer.js